import dayjs from 'dayjs';
import { Card, DatePicker, Empty, Form, Input, Select, Switch } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { IProduct } from 'interfaces/products';
import { IProductBonus } from 'interfaces/product_bonuses';
import { IUser } from 'interfaces/users';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SalesIconComponent } from 'assets/icons/sales';
import { useForm, useSelect } from '@refinedev/antd';
import { useState } from 'react';

export const BonusCreate = () => {
  const { formProps, saveButtonProps } = useForm<IProductBonus>();
  const { selectProps: userSelectProps } = useSelect<IUser>({
    resource: 'users',
    optionLabel: 'email',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[email]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  const { selectProps: productSelectProps } = useSelect<IProduct>({
    resource: 'products',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server',
      pageSize: 100
    }
  });

  const [isAllProducts, setIsAllProducts] = useState(false);

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar Bônus" icon={SalesIconComponent} />
      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Usuário"
            name="user_id"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select {...userSelectProps} />
          </Form.Item>
          <Form.Item
            label="Acesso a todos os cursos"
            name="is_full_products"
            initialValue={false}
            rules={[
              {
                required: true
              }
            ]}
          >
            <Switch onChange={setIsAllProducts} />
          </Form.Item>
          <Form.Item
            label="Produto"
            name="product_id"
            rules={[
              {
                required: !isAllProducts
              }
            ]}
            hidden={isAllProducts}
          >
            <Select
              {...productSelectProps}
              notFoundContent={
                <Empty description="Nenhum produto encontrado. Tente refazer sua busca com outros termos" />
              }
            />
          </Form.Item>
          <Form.Item
            label="Motivo"
            name="motive"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="Expiração"
            name="expires_at"
            getValueProps={value => {
              return {
                value: value ? dayjs(value) : ''
              };
            }}
            rules={[
              {
                required: true
              }
            ]}
          >
            <DatePicker />
          </Form.Item>
          <Form.Item
            label="Criar nova matrícula"
            name="new_enrollment"
            initialValue={false}
            valuePropName="checked"
            hidden={isAllProducts}
          >
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
